"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSettingsHelper = exports.legacyNavigationSettingsSchemaWithoutDefaults = void 0;
var BlockTokenTraverser_1 = require("@CommonFrontendBackend/Blocks/BlockTokenTraverser");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var zod_1 = __importDefault(require("zod"));
var defaultBackgroundColor = { themeIndex: -1, abs: "white" };
var defaultCTAConfig = { type: "accept" };
var makeLegacyNavigationSettingsSchema = function (_a) {
    var withDefaults = _a.withDefaults;
    var maybeDefaultWithOptional = function (object, defaultValue) { return (withDefaults ? object.default(defaultValue) : object.optional()); };
    return zod_1.default.object({
        settings: zod_1.default.object({
            navigation: zod_1.default
                .object({
                enabled: zod_1.default.enum(["", "header", "sidebar"]),
                widgets: zod_1.default
                    .object({
                    header: zod_1.default
                        .object({
                        fixed: zod_1.default.boolean().default(true),
                        showContact: zod_1.default.boolean().default(false),
                    })
                        .default({
                        fixed: true,
                        showContact: false,
                    }),
                    sidebar: zod_1.default
                        .object({
                        showContact: zod_1.default.boolean().default(false),
                    })
                        .default({
                        showContact: false,
                    }),
                })
                    .default({
                    header: { fixed: true, showContact: true },
                    sidebar: { showContact: true },
                }),
                v2: zod_1.default.any().transform(function (v) {
                    if (Object.entries(v !== null && v !== void 0 ? v : {}).length === 0) {
                        return undefined;
                    }
                    return zod_1.default
                        .object({
                        layout: zod_1.default.enum(["top", "left", "floating"]),
                        showContact: zod_1.default.boolean(),
                        showDrawer: zod_1.default.boolean(),
                        backgroundColor: maybeDefaultWithOptional(zod_1.default.object({ themeIndex: zod_1.default.number().nullable().optional(), abs: zod_1.default.string() }), defaultBackgroundColor),
                        springboardMenuEnabled: zod_1.default.boolean(),
                        showQuoteTotal: zod_1.default.boolean(),
                        cta: maybeDefaultWithOptional(zod_1.default.object({
                            type: zod_1.default.enum(["none", "accept"]),
                        }), __assign({}, defaultCTAConfig)),
                    })
                        .parse(v);
                }),
            })
                .default({
                enabled: "",
                widgets: {
                    header: { fixed: true, showContact: true },
                    sidebar: { showContact: true },
                },
            }),
            springboard: zod_1.default
                .object({
                engagementMenuEnabled: zod_1.default.boolean().default(true),
                contactPageOwnerEnabled: zod_1.default.boolean().default(true),
            })
                .default({
                engagementMenuEnabled: true,
                contactPageOwnerEnabled: true,
            }),
        }),
        blocks: zod_1.default.array(zod_1.default.object({
            _id: zod_1.default.any().transform(function (v) { return v.toString(); }),
            name: zod_1.default.string().default(""),
            style: zod_1.default
                .object({
                acceptButton: zod_1.default
                    .object({
                    color: zod_1.default
                        .object({
                        abs: zod_1.default.string().optional(),
                        themeIndex: zod_1.default.number().optional().nullable(),
                    })
                        .optional(),
                })
                    .optional(),
            })
                .optional(),
            settings: zod_1.default.object({
                navigation: zod_1.default
                    .object({
                    exclude: zod_1.default.boolean(),
                })
                    .default({ exclude: false }),
                button: zod_1.default.object({ customLabel: zod_1.default.string().optional() }).optional(),
            }),
            type: zod_1.default.string(),
            contentAreas: zod_1.default.any(),
            agreement: zod_1.default
                .any()
                .optional()
                .transform(function (v) {
                if (v) {
                    return v.toString();
                }
                else {
                    return undefined;
                }
            }),
        })),
    });
};
var legacyNavigationSettingsSchema = makeLegacyNavigationSettingsSchema({ withDefaults: true });
exports.legacyNavigationSettingsSchemaWithoutDefaults = makeLegacyNavigationSettingsSchema({
    withDefaults: false,
});
var emerald = "#00857b";
var NavigationSettingsHelper = (function () {
    function NavigationSettingsHelper() {
    }
    NavigationSettingsHelper.fromLegacy = function (oldSettings) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var legacySettings = legacyNavigationSettingsSchema.parse(oldSettings);
        var originalSettings = legacySettings.settings;
        var items = legacySettings.blocks.map(function (block) { return (__assign({ name: block.name, blockId: block._id, show: !block.settings.navigation.exclude, type: block.type, contentAreas: block.contentAreas, defaultLabel: _this.defaultBlockName(block), style: block.style }, (0, CommonUtils_1.includeIf)(!!block.agreement, { agreement: block.agreement }))); });
        var acceptBlock = legacySettings.blocks.find(function (block) { return block.type === "Accept"; });
        var accept;
        var originalAcceptLabel;
        if (acceptBlock) {
            var label = "";
            if (!!((_b = (_a = acceptBlock === null || acceptBlock === void 0 ? void 0 : acceptBlock.settings) === null || _a === void 0 ? void 0 : _a.button) === null || _b === void 0 ? void 0 : _b.customLabel)) {
                label = acceptBlock.settings.button.customLabel;
            }
            else {
                label = acceptBlock.agreement ? "View agreement" : "Accept";
            }
            accept = {
                color: {
                    abs: (_f = (_e = (_d = (_c = acceptBlock === null || acceptBlock === void 0 ? void 0 : acceptBlock.style) === null || _c === void 0 ? void 0 : _c.acceptButton) === null || _d === void 0 ? void 0 : _d.color) === null || _e === void 0 ? void 0 : _e.abs) !== null && _f !== void 0 ? _f : emerald,
                    themeIndex: (_j = (_h = (_g = acceptBlock === null || acceptBlock === void 0 ? void 0 : acceptBlock.style) === null || _g === void 0 ? void 0 : _g.acceptButton) === null || _h === void 0 ? void 0 : _h.color) === null || _j === void 0 ? void 0 : _j.themeIndex,
                },
                label: label,
            };
            originalAcceptLabel = (_l = (_k = acceptBlock === null || acceptBlock === void 0 ? void 0 : acceptBlock.settings) === null || _k === void 0 ? void 0 : _k.button) === null || _l === void 0 ? void 0 : _l.customLabel;
        }
        var originalSpringboardSettings = legacySettings.settings.springboard;
        if (originalSettings.navigation.v2) {
            return __assign(__assign({}, originalSettings.navigation.v2), { items: items, originalSettings: originalSettings, originalAcceptLabel: originalAcceptLabel, accept: !!acceptBlock ? accept : undefined });
        }
        switch (legacySettings.settings.navigation.enabled) {
            case "header":
                return {
                    layout: "top",
                    showDrawer: true,
                    showQuoteTotal: true,
                    showContact: legacySettings.settings.navigation.widgets.header.showContact &&
                        originalSpringboardSettings.contactPageOwnerEnabled,
                    springboardMenuEnabled: originalSpringboardSettings.engagementMenuEnabled,
                    accept: !!acceptBlock ? accept : undefined,
                    items: items,
                    originalSettings: originalSettings,
                    originalAcceptLabel: originalAcceptLabel,
                    backgroundColor: defaultBackgroundColor,
                    cta: __assign({}, defaultCTAConfig),
                };
            case "sidebar":
                return {
                    layout: "left",
                    showDrawer: true,
                    showQuoteTotal: false,
                    showContact: legacySettings.settings.navigation.widgets.sidebar.showContact &&
                        originalSpringboardSettings.contactPageOwnerEnabled,
                    springboardMenuEnabled: originalSpringboardSettings.engagementMenuEnabled,
                    accept: !!acceptBlock ? accept : undefined,
                    items: items,
                    originalSettings: originalSettings,
                    originalAcceptLabel: originalAcceptLabel,
                    backgroundColor: defaultBackgroundColor,
                    cta: __assign({}, defaultCTAConfig),
                };
            case "":
                return {
                    layout: "left",
                    showDrawer: false,
                    showQuoteTotal: false,
                    showContact: legacySettings.settings.navigation.widgets.sidebar.showContact &&
                        originalSpringboardSettings.contactPageOwnerEnabled,
                    springboardMenuEnabled: originalSpringboardSettings.engagementMenuEnabled,
                    accept: !!acceptBlock ? accept : undefined,
                    items: items,
                    originalSettings: originalSettings,
                    originalAcceptLabel: originalAcceptLabel,
                    backgroundColor: defaultBackgroundColor,
                    cta: __assign({}, defaultCTAConfig),
                };
        }
    };
    NavigationSettingsHelper.toLegacy = function (settings) {
        return {
            settings: {
                navigation: __assign(__assign({}, settings.originalSettings.navigation), { v2: {
                        layout: settings.layout,
                        showDrawer: settings.showDrawer,
                        showContact: settings.showContact,
                        backgroundColor: settings.backgroundColor,
                        springboardMenuEnabled: settings.springboardMenuEnabled,
                        showQuoteTotal: settings.showQuoteTotal,
                        cta: settings.cta,
                    } }),
            },
            blocks: settings.items.map(function (item) {
                if (item.type === "Accept") {
                    return __assign({ name: item.name, _id: item.blockId, settings: {
                            navigation: { exclude: !item.show },
                            button: { customLabel: settings.originalAcceptLabel },
                        }, style: item.style, type: item.type, contentAreas: item.contentAreas }, (0, CommonUtils_1.includeIf)(!!item.agreement, { agreement: item.agreement }));
                }
                return {
                    name: item.name,
                    _id: item.blockId,
                    settings: { navigation: { exclude: !item.show } },
                    style: item.style,
                    type: item.type,
                    contentAreas: item.contentAreas,
                };
            }),
        };
    };
    NavigationSettingsHelper.defaultBlockName = function (block) {
        var e_1, _a, e_2, _b;
        var blockTokenTraverser = new BlockTokenTraverser_1.BlockTokenTraverser();
        var name = "";
        var collectText = false;
        try {
            for (var _c = __values(blockTokenTraverser.traverseBlockForTokens(block)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var contentArea = _d.value;
                try {
                    for (var contentArea_1 = (e_2 = void 0, __values(contentArea)), contentArea_1_1 = contentArea_1.next(); !contentArea_1_1.done; contentArea_1_1 = contentArea_1.next()) {
                        var token = contentArea_1_1.value;
                        if (token.type === "block" && ["heading1", "heading2"].includes(token.subType) && !collectText) {
                            collectText = true;
                        }
                        else if (token.type === "block" && collectText) {
                            return name || "Untitled";
                        }
                        else if (collectText) {
                            name += token.content;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (contentArea_1_1 && !contentArea_1_1.done && (_b = contentArea_1.return)) _b.call(contentArea_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return name || "Untitled";
    };
    return NavigationSettingsHelper;
}());
exports.NavigationSettingsHelper = NavigationSettingsHelper;
